import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectMeetingQuestionApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-meeting-question'
    }

}